import { useContext } from 'react';
import LocalizationContext from '../context/LocalizationContext';

/**
 * Custom hook to access localization context
 * @returns {Object} The translations object for current language
 */
const useLocalization = () => {
  const translations = useContext(LocalizationContext);
  
  if (!translations) {
    throw new Error('useLocalization must be used within a LocalizationProvider');
  }
  
  return translations;
};

export default useLocalization;